import background from 'shared/styles/color/background';
import border from 'shared/styles/color/border';
import dataVis from 'shared/styles/color/dataVis';
import expressive from 'shared/styles/color/expressive';
import interactive from 'shared/styles/color/interactive';
import status from 'shared/styles/color/status';
import text from 'shared/styles/color/text';
import spacing from 'shared/styles/spacing';
import typography from 'shared/styles/typography';

export default {
  color: {
    background,
    border,
    dataVis,
    expressive,
    interactive,
    status,
    text,
  },
  spacing,
  typography,
};
